const homeAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      /* GSAP ANIMATIONS */

      //Smooth content

      ScrollSmoother.create({
        wrapper: "#smooth-container",
        content: "#smooth-content",
        smooth: 0.8,
        effects: true,
      });

    
      const logo = document.querySelector("svg.logo");
      const square = document.querySelector("div.presentation");

      // Vérifier si c'est un écran mobile
      const isMobile = window.innerWidth < 900;

      if (isMobile) {
        gsap.set(logo, { opacity: 0 });
        gsap.to(logo, { opacity: 1, duration: 1.5, delay: 0.2});

        const timelineHeaderMobile = gsap.timeline({
          scrollTrigger: {
            trigger: "section#mobile-presentation",
            //scrub: true,
            start: "top 80%",
            end: "+=50% 0",
            //pin: true,
            markers: false,
            invalidateOnRefresh: true,
          },
        });

        timelineHeaderMobile
          .to(
            "h1.second-line",
            {
              opacity: 1,
              x: 0,
            },
            0
          )
          .to(
            ".first-line",
            {
              y: 0,
              opacity: 1,
              ease: "power4.out",
              //skewY: 7,
            },
            0
          ); 


        // Animation du photo-cover au scroll (mobile)
        const photoCoverTimelineMobile = gsap.timeline({
          scrollTrigger: {
            trigger: "#mobile-presentation .presentation-photo-container",
            start: "top 80%",
            end: "top 20%",
            scrub: true,
            markers: false,
            invalidateOnRefresh: true,
          },
        });

        photoCoverTimelineMobile.to(".photo-cover", {
          y: "100%",
        });

        // Animation de la description au scroll (mobile)
        const descriptionTimelineMobile = gsap.timeline({
          scrollTrigger: {
            trigger: "#mobile-presentation .presentation-description",
            start: "top 80%",
            end: "top 20%",
            scrub: true,
            markers: false,
            invalidateOnRefresh: true,
          },
        });

        descriptionTimelineMobile.to(
          "#mobile-presentation .presentation-description p, #mobile-presentation .presentation-description ul li",
          {
            y: 0,
            opacity: 1,
            stagger: 0.2,
          }
        );

          return;
      } 

      let logoToScale = () => (window.innerWidth / logo.getBBox().width) * 27;

      gsap.set(square, {
        position: "absolute",
        top: "50%",
        left: "50%",
        x: "-50%",
        y: "-50%",
        width: "100vw",
        minHeight: "100vh",
        scale: 0,
      });
      const timelineHeader = gsap.timeline({
        scrollTrigger: {
          id: "ZOOM",
          trigger: "section#hero",
          scrub: true,
          start: "top top",
          end: "+=250% 0",
          pin: true,
          markers: false,
          invalidateOnRefresh: true,
        },
      });

      timelineHeader
        .to(
          logo,
          {
            duration: 1,
            ease: "none",
            scale: () => logoToScale(),
          },
          0
        )
        .to(
          square,
          {
            scale: 1,
      
            transformOrigin: "center",
            opacity: 1,
            duration: 1,
            ease: "none",
          },
          0
        )
        .to(
          "h1.second-line",
          {
            opacity: 1,
            x: 0,
          },
          1
        )
        .to(
          ".first-line",
          {
            y: 0,
            opacity: 1,
            ease: "power4.out",
            //skewY: 7,
          },
          1
        )
        .to(
          ".photo-cover",
          {
            y: "100%",
          },
          1
        )
        .to(
          ".presentation-description p, .presentation-description ul li",
          {
            y: 0,
            opacity: 1,
            stagger: 0.2,
          },
          1
        ); 
    });
  },
};

export default homeAnim;
